
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { Controlador as Model, ControladorInterfaz } from '../../controlador';
    import { Articulo } from '@/__env/lib/Articulos';
    import { Publicacion } from '@/__env/lib/MercadoLibre/Publicaciones';
    import descripcion from './resumen-editar-descripcion.vue';
    import { Utiles } from '@/__env/pluggins/event-bus';
    import moment, { Moment } from 'moment';
import { Wait } from '@/__env/ext';
    @Component( {
        name: "Componente",
        props: {},
        components: {
            descripcion
        }
    } )
    export default class Componente extends Vue
    {
        @Prop()
        public Controlador: ControladorInterfaz;
        public get Publicacion() { return this.Controlador.Publicacion; }
        public get Estado() { return this.Controlador.Vista.Estado; }

        public Cargando: boolean = false;
        public EditarDescripcion: boolean = false;

        public Precio: number = 0;
        public Stock: number = 0;
        public Codigo: Articulo = null;
        public Modificada: Moment = null;
        public Ok()
        {
            return ( this.Precio && this.Precio != this.Publicacion.Precio ) ||
                ( this.Stock != this.Publicacion.Stock ) ||
                ( this.Codigo && this.Codigo.Existe && ( !this.Controlador.Articulo || this.Codigo.Id != this.Controlador.Articulo.Id ) );
        }

        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );
        }

        mounted()
        {
            this.Eventos.push( this.Controlador.Vista.onEstado.subscribe( x => this.Iniciar() ) );
            this.Iniciar();
        }

        ActualizarCodigo( x: Articulo )
        {
            this.Modificada = moment();
            this.Controlador.Articulo = x;
            this.Refrescar();
            this.Iniciar();
        }
        Iniciar()
        {
            if ( this.Estado != 'iniciado' )
                return;
            this.Precio = this.Publicacion.Precio;
            this.Stock = this.Publicacion.Stock;
            this.Codigo = this.Controlador.Articulo;
            this.Controlador.RecargarDescripcion();
            this.Refrescar();
        }

        public CargandoTipo: boolean = false;
        async ConvertirEnFinanciada()
        {
            this.CargandoTipo= true;
            let e = await this.Publicacion.ConvertirEnFinaciada();
            if ( !e )
            {
                Utiles.Notificaciones.Error( 'Error al modificar la publicación' );
            } else
            {
                this.Modificada = moment();
                this.Iniciar();
            }
            this.CargandoTipo= false;


        }

        async Guardar()
        {
            if ( this.CargandoTipo )
                return;

            this.Cargando = true;
            if ( ( this.Stock > 0 && this.Stock != this.Publicacion.Stock ) || ( this.Precio > 0 && this.Precio != this.Publicacion.Precio ) )
            {
                let e = await this.Publicacion.Modificar(
                    ( this.Stock > 0 && this.Stock != this.Publicacion.Stock ? this.Stock : null ),
                    ( this.Precio > 0 && this.Precio != this.Publicacion.Precio ? this.Precio : null )
                );
                if ( !e )
                {
                    Utiles.Notificaciones.Error( 'Error al modificar la publicación' );
                }
                else
                {
                    if ( this.Codigo && this.Codigo.Existe && ( !this.Controlador.Articulo || this.Codigo.Id != this.Controlador.Articulo.Id ) )
                    {
                        this.EditarDescripcion = !this.EditarDescripcion;
                    } else
                    {
                        this.Modificada = moment();
                        this.Iniciar();
                    }


                }
            } else
            {
                if ( this.Codigo && this.Codigo.Existe && ( !this.Controlador.Articulo || this.Codigo.Id != this.Controlador.Articulo.Id ) )
                {
                    this.EditarDescripcion = !this.EditarDescripcion;
                }
            }
            this.Cargando = false;



        }

        public Refresh: boolean = true;
        public Refrescar()
        {
            this.Refresh = false;
            this.$nextTick( () => this.Refresh = true );
        }
    }
